import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChannelListPhysicalSocketsCell } from './channel-list-physical-sockets.cell';
import { ChannelListPhysicalSocketsHeader } from './channel-list-physical-sockets.header';

export const ChannelListPhysicalSocketsColumn: IdentifiedColumnDef<
  GatewayChannelWithChargePointInfoModel,
  GatewayChannelWithChargePointInfoModel['physicalSockets']
> = {
  enableSorting: false,
  header: ChannelListPhysicalSocketsHeader,
  cell: ChannelListPhysicalSocketsCell,
};
